import { ModuleInfoResponse } from '../models/ModuleInfoResponse';
import { MenuResponse } from '../models/MenuResponse';
import { SidebarTreeNode } from '../models/SidebarTreeNode';
import { viewParamsToString } from '../models/ViewParams';
import { WidgetAction } from '../models/Widget/actions/WidgetAction';

export const moduleResponseToTreeNode = (
  modules: Array<ModuleInfoResponse>,
): Array<SidebarTreeNode> =>
  modules.map((m) => ({
    title: m.title,
    key: m.name,
    selectable: false,
    children: [],
    isLeaf: false,
    parentNode: null,
    moduleKey: m.name,
    id: null,
    sidebarNodeAction: null,
    iconUrl: m.iconUrl,
  }));

export const moduleMenuItemToTreeNode = (
  parentNode: SidebarTreeNode,
  items: Array<MenuResponse>,
): Array<SidebarTreeNode> =>
  items.map((i) => {
    const addRequestId = (action: WidgetAction, parentNode: SidebarTreeNode) => {
      return action.requestIdentity.id
        ? action.requestIdentity
        : {
            ...action.requestIdentity,
            id: parentNode.sidebarNodeActions[0].requestIdentity.id,
          };
    };
    const addParentActionId =
      (parentNode: SidebarTreeNode) =>
      (action: WidgetAction): WidgetAction => ({
        ...(action.requestIdentity.id
          ? action
          : {
              ...action,
              requestIdentity: addRequestId(action, parentNode),
            }),
      });

    return {
      title: i.displayName,
      key: viewParamsToString({
        moduleKey: parentNode.moduleKey,
        ...addRequestId(i.actions[0], parentNode),
      }),
      selectable: true,
      children: [],
      isLeaf: !i.hasChildren,
      parentNode,
      moduleKey: parentNode.moduleKey,
      id: i.id,
      sidebarNodeActions: i.actions.map(addParentActionId(parentNode)),
      iconUrl: null,
    };
  });
